import { render, staticRenderFns } from "./SocAnalysis.vue?vue&type=template&id=45b0eccb"
import script from "./SocAnalysis.vue?vue&type=script&lang=js"
export * from "./SocAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SocAnalysis.vue?vue&type=style&index=0&id=45b0eccb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports